import { render } from "./index.vue?vue&type=template&id=73be484e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=73be484e&lang=css"
script.render = render

export default script